import _Object$entries from "@babel/runtime-corejs3/core-js-stable/object/entries";
import { isVue2, reactive } from 'vue-demi';

// 返回 vue3 $slots
export function useSlots(vm) {
  if (isVue2) {
    const slots = reactive({});
    const setProperties = function setProperties(key, value) {
      slots[key] = function () {
        if (typeof value === 'function') {
          return value(...arguments);
        }
        return value;
      };
    };
    for (const [key, value] of _Object$entries(vm.$slots)) {
      setProperties(key, value);
    }
    for (const [key, value] of _Object$entries(vm.$scopedSlots)) {
      setProperties(key, value);
    }
    return slots;
  }
  return vm === null || vm === void 0 ? void 0 : vm.$slots;
}